import { useEffect, useState } from "react";

export default function AnnouncementPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true); 
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-md p-6 text-center animate-scaleIn">
        
        <h2 className="text-red-600 text-xl font-semibold mb-2">
          Important Announcement
        </h2>

        <p className="text-gray-600 text-sm mb-3">
          We are sorry to inform you that currently shipping is not available in these areas:
        </p>

        <p className="font-medium text-gray-800 text-sm leading-6">
          California <br />
          New York <br />
          Rhode Island <br />
          Utah <br />
          Maryland <br />
          Washington DC <br />
          Columbus <br />
          Colorado
        </p>

        <p className="text-gray-600 text-sm mt-3">
          Please contact for any further inquiry:
        </p>

        <p className="font-semibold mt-1">📞 804-306-6387</p>

        <button
          onClick={handleClose}
          className="mt-5 bg-black text-white px-5 py-2 rounded-lg hover:bg-gray-800 transition"
        >
          Close
        </button>
      </div>
    </div>
  );
}
